module.exports = __webpack_public_path__ + "img/dr.9e6d04c5.png";